import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJestComponent } from './simple-icons-jest.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJestComponent ],
    exports:      [ SimpleIconsJestComponent ],
    bootstrap:    []
})
export class SimpleIconsJestModule {}
